<template>
  <div :disabled="locked" class="pure-css-select-style choose-answer">
    <select
      :value="selectedOption"
      :disabled="locked"
      @input="$emit('answer-updated', $event.target.value)"
    >
      <option :value="null" disabled>Choose an answer</option>
      <option v-for="(option, index) in options" :key="index" :value="index">{{
        option.text
      }}</option>
    </select>
  </div>
</template>

<script>
export default {
  props: {
    options: Array,
    selectedOption: { type: [Number, String] },
    locked: Boolean
  }
}
</script>
